import { CreateElement, VNode } from 'vue'

import { Logo } from '@src/elements/logo/logo'
import { Spacer } from '@src/elements/spacer/spacer'
import { Input } from '@src/elements/input/input'
import { Sidebar, NavItem } from '@src/components/sidebar/sidebar'
import { MobileOnly } from '@src/components/mobile-only/mobile-only'
import { Divider } from '@src/elements/divider/divider'
import { Stopwatch } from '@src/components/stopwatch/stopwatch'

export function renderComponents (h: CreateElement): VNode[] {
  let sidebar =
    <Sidebar ref='sidebar'>
      <Logo ref='logo' type='responsive' slot='top' />

      <MobileOnly ref='mobile-only'>
        <Input ref='input-search' icon={'brand/search-small'} placeholder={'Search'} />
      </MobileOnly>

      <NavItem ref='navitem-dashboard' icon={'brand/dashboard'} label={'Dashboard'} selected={true} badge={'88'} />
      <NavItem ref='navitem-members' icon={'sidebar/members'} label={'Members'} />
      <NavItem ref='navitem-exercise' icon={'sidebar/exercise'} label={'Exercises'} />

      <Spacer ref='spacer' />

      <NavItem ref='navitem-stations' icon={'sidebar/stations'} label={'Stations'} />

      <Divider ref='divider' slot={'bottom'} />

      <NavItem ref='navitem-profile' icon={'brand/profile'} label={'Full Name'} slot={'bottom'} />

    </Sidebar>

  let stopwatch =
    <Stopwatch ref='stopwatch' radius={160} stroke={18} counter={12} progress={60} projection={65}></Stopwatch>

  return [
    sidebar,

    stopwatch
  ]
}
